/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllCuratorTaskRecordsForPatientQueryVariables = Types.Exact<{
  input: Types.GetCuratorTasksForPatientInput;
}>;


export type GetAllCuratorTaskRecordsForPatientQuery = { __typename?: 'Query', getAllCuratorTaskRecordsForPatient: { __typename?: 'GetAllCuratorTaskResponse', success: boolean, message: string, data?: Array<{ __typename?: 'CuratorTaskModel', user_id?: string | null, curator_task_id: string, vitall_patient_id: string, status: boolean, priority: number, name: string, description?: string | null, created_user_id?: string | null, due_date?: string | null, route?: string | null, recordDescription?: string | null, created_at: string, updated_at: string, user?: { __typename?: 'UserModel', first_name: string, last_name: string, user_id: string, account_id: string, created_at: string, updated_at: string } | null }> | null } };

export type GetAllCuratorTaskRecordsQueryVariables = Types.Exact<{
  input: Types.GetCuratorTasksInput;
}>;


export type GetAllCuratorTaskRecordsQuery = { __typename?: 'Query', getAllCuratorTaskRecords: { __typename?: 'GetAllCuratorTaskResponse', success: boolean, message: string, data?: Array<{ __typename?: 'CuratorTaskModel', user_id?: string | null, curator_task_id: string, status: boolean, priority: number, name: string, description?: string | null, created_user_id?: string | null, due_date?: string | null, route?: string | null, recordDescription?: string | null, created_at: string, updated_at: string, vitall_patient_id: string, user?: { __typename?: 'UserModel', first_name: string, last_name: string, user_id: string, account_id: string, created_at: string, updated_at: string } | null, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, allow_emergency_access: boolean, patient_id: string, user?: { __typename?: 'UserModel', first_name: string, last_name: string, user_id: string, account_id: string, created_at: string, updated_at: string } | null } | null }> | null } };

export type GetCuratorTaskRecordQueryVariables = Types.Exact<{
  input: Types.GetCuratorTaskInput;
}>;


export type GetCuratorTaskRecordQuery = { __typename?: 'Query', getCuratorTaskRecord: { __typename?: 'UpdateCuratorTaskResponse', message: string, success: boolean, data?: { __typename?: 'CuratorTaskModel', user_id?: string | null, curator_task_id: string, vitall_patient_id: string, status: boolean, priority: number, name: string, description?: string | null, created_user_id?: string | null, due_date?: string | null, route?: string | null, recordDescription?: string | null, created_at: string, updated_at: string } | null } };

export type PostCuratorTaskRecordMutationVariables = Types.Exact<{
  input: Types.CreateCuratorTaskModelInput;
}>;


export type PostCuratorTaskRecordMutation = { __typename?: 'Mutation', postCuratorTaskRecord: { __typename?: 'CuratorTaskModel', user_id?: string | null, curator_task_id: string, vitall_patient_id: string, status: boolean, priority: number, name: string, description?: string | null, created_user_id?: string | null, due_date?: string | null, route?: string | null, recordDescription?: string | null, created_at: string, updated_at: string } };

export type UpdateCuratorTaskRecordMutationVariables = Types.Exact<{
  input: Types.UpdateCuratorTaskInput;
}>;


export type UpdateCuratorTaskRecordMutation = { __typename?: 'Mutation', updateCuratorTaskRecord: { __typename?: 'UpdateCuratorTaskResponse', message: string, success: boolean, data?: { __typename?: 'CuratorTaskModel', curator_task_id: string, vitall_patient_id: string, user_id?: string | null, name: string, description?: string | null, created_user_id?: string | null, priority: number, due_date?: string | null, status: boolean, route?: string | null, recordDescription?: string | null } | null } };

export type DeleteCuratorTaskRecordMutationVariables = Types.Exact<{
  input: Types.GetCuratorTaskInput;
}>;


export type DeleteCuratorTaskRecordMutation = { __typename?: 'Mutation', deleteCuratorTaskRecord: { __typename?: 'UpdateCuratorTaskResponse', message: string, success: boolean, data?: { __typename?: 'CuratorTaskModel', curator_task_id: string } | null } };


export const GetAllCuratorTaskRecordsForPatientDocument = gql`
    query getAllCuratorTaskRecordsForPatient($input: GetCuratorTasksForPatientInput!) {
  getAllCuratorTaskRecordsForPatient(input: $input) {
    success
    message
    data {
      user_id
      curator_task_id
      vitall_patient_id
      user_id
      status
      priority
      name
      description
      created_user_id
      due_date
      route
      recordDescription
      created_at
      updated_at
      user {
        first_name
        last_name
        user_id
        account_id
        created_at
        updated_at
      }
    }
  }
}
    `;
export function useGetAllCuratorTaskRecordsForPatientQuery(baseOptions: Apollo.QueryHookOptions<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables> & ({ variables: GetAllCuratorTaskRecordsForPatientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>(GetAllCuratorTaskRecordsForPatientDocument, options);
      }
export function useGetAllCuratorTaskRecordsForPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>(GetAllCuratorTaskRecordsForPatientDocument, options);
        }
// @ts-ignore
export function useGetAllCuratorTaskRecordsForPatientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>;
export function useGetAllCuratorTaskRecordsForPatientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCuratorTaskRecordsForPatientQuery | undefined, GetAllCuratorTaskRecordsForPatientQueryVariables>;
export function useGetAllCuratorTaskRecordsForPatientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>(GetAllCuratorTaskRecordsForPatientDocument, options);
        }
export type GetAllCuratorTaskRecordsForPatientQueryHookResult = ReturnType<typeof useGetAllCuratorTaskRecordsForPatientQuery>;
export type GetAllCuratorTaskRecordsForPatientLazyQueryHookResult = ReturnType<typeof useGetAllCuratorTaskRecordsForPatientLazyQuery>;
export type GetAllCuratorTaskRecordsForPatientSuspenseQueryHookResult = ReturnType<typeof useGetAllCuratorTaskRecordsForPatientSuspenseQuery>;
export type GetAllCuratorTaskRecordsForPatientQueryResult = Apollo.QueryResult<GetAllCuratorTaskRecordsForPatientQuery, GetAllCuratorTaskRecordsForPatientQueryVariables>;
export const GetAllCuratorTaskRecordsDocument = gql`
    query getAllCuratorTaskRecords($input: GetCuratorTasksInput!) {
  getAllCuratorTaskRecords(input: $input) {
    success
    message
    data {
      user_id
      curator_task_id
      status
      priority
      name
      description
      created_user_id
      due_date
      route
      recordDescription
      created_at
      updated_at
      user {
        first_name
        last_name
        user_id
        account_id
        created_at
        updated_at
      }
      vitall_patient_id
      vitall_patient {
        vitall_patient_id
        allow_emergency_access
        patient_id
        user {
          first_name
          last_name
          user_id
          account_id
          created_at
          updated_at
        }
      }
    }
  }
}
    `;
export function useGetAllCuratorTaskRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables> & ({ variables: GetAllCuratorTaskRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>(GetAllCuratorTaskRecordsDocument, options);
      }
export function useGetAllCuratorTaskRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>(GetAllCuratorTaskRecordsDocument, options);
        }
// @ts-ignore
export function useGetAllCuratorTaskRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>;
export function useGetAllCuratorTaskRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCuratorTaskRecordsQuery | undefined, GetAllCuratorTaskRecordsQueryVariables>;
export function useGetAllCuratorTaskRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>(GetAllCuratorTaskRecordsDocument, options);
        }
export type GetAllCuratorTaskRecordsQueryHookResult = ReturnType<typeof useGetAllCuratorTaskRecordsQuery>;
export type GetAllCuratorTaskRecordsLazyQueryHookResult = ReturnType<typeof useGetAllCuratorTaskRecordsLazyQuery>;
export type GetAllCuratorTaskRecordsSuspenseQueryHookResult = ReturnType<typeof useGetAllCuratorTaskRecordsSuspenseQuery>;
export type GetAllCuratorTaskRecordsQueryResult = Apollo.QueryResult<GetAllCuratorTaskRecordsQuery, GetAllCuratorTaskRecordsQueryVariables>;
export const GetCuratorTaskRecordDocument = gql`
    query getCuratorTaskRecord($input: GetCuratorTaskInput!) {
  getCuratorTaskRecord(input: $input) {
    message
    success
    data {
      user_id
      curator_task_id
      vitall_patient_id
      user_id
      status
      priority
      name
      description
      created_user_id
      due_date
      route
      recordDescription
      created_at
      updated_at
    }
  }
}
    `;
export function useGetCuratorTaskRecordQuery(baseOptions: Apollo.QueryHookOptions<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables> & ({ variables: GetCuratorTaskRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>(GetCuratorTaskRecordDocument, options);
      }
export function useGetCuratorTaskRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>(GetCuratorTaskRecordDocument, options);
        }
// @ts-ignore
export function useGetCuratorTaskRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>;
export function useGetCuratorTaskRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetCuratorTaskRecordQuery | undefined, GetCuratorTaskRecordQueryVariables>;
export function useGetCuratorTaskRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>(GetCuratorTaskRecordDocument, options);
        }
export type GetCuratorTaskRecordQueryHookResult = ReturnType<typeof useGetCuratorTaskRecordQuery>;
export type GetCuratorTaskRecordLazyQueryHookResult = ReturnType<typeof useGetCuratorTaskRecordLazyQuery>;
export type GetCuratorTaskRecordSuspenseQueryHookResult = ReturnType<typeof useGetCuratorTaskRecordSuspenseQuery>;
export type GetCuratorTaskRecordQueryResult = Apollo.QueryResult<GetCuratorTaskRecordQuery, GetCuratorTaskRecordQueryVariables>;
export const PostCuratorTaskRecordDocument = gql`
    mutation postCuratorTaskRecord($input: CreateCuratorTaskModelInput!) {
  postCuratorTaskRecord(input: $input) {
    user_id
    curator_task_id
    vitall_patient_id
    user_id
    status
    priority
    name
    description
    created_user_id
    due_date
    route
    recordDescription
    created_at
    updated_at
  }
}
    `;
export type PostCuratorTaskRecordMutationFn = Apollo.MutationFunction<PostCuratorTaskRecordMutation, PostCuratorTaskRecordMutationVariables>;
export function usePostCuratorTaskRecordMutation(baseOptions?: Apollo.MutationHookOptions<PostCuratorTaskRecordMutation, PostCuratorTaskRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCuratorTaskRecordMutation, PostCuratorTaskRecordMutationVariables>(PostCuratorTaskRecordDocument, options);
      }
export type PostCuratorTaskRecordMutationHookResult = ReturnType<typeof usePostCuratorTaskRecordMutation>;
export type PostCuratorTaskRecordMutationResult = Apollo.MutationResult<PostCuratorTaskRecordMutation>;
export type PostCuratorTaskRecordMutationOptions = Apollo.BaseMutationOptions<PostCuratorTaskRecordMutation, PostCuratorTaskRecordMutationVariables>;
export const UpdateCuratorTaskRecordDocument = gql`
    mutation updateCuratorTaskRecord($input: UpdateCuratorTaskInput!) {
  updateCuratorTaskRecord(input: $input) {
    message
    success
    data {
      curator_task_id
      vitall_patient_id
      user_id
      name
      description
      created_user_id
      priority
      due_date
      status
      route
      recordDescription
    }
  }
}
    `;
export type UpdateCuratorTaskRecordMutationFn = Apollo.MutationFunction<UpdateCuratorTaskRecordMutation, UpdateCuratorTaskRecordMutationVariables>;
export function useUpdateCuratorTaskRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCuratorTaskRecordMutation, UpdateCuratorTaskRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCuratorTaskRecordMutation, UpdateCuratorTaskRecordMutationVariables>(UpdateCuratorTaskRecordDocument, options);
      }
export type UpdateCuratorTaskRecordMutationHookResult = ReturnType<typeof useUpdateCuratorTaskRecordMutation>;
export type UpdateCuratorTaskRecordMutationResult = Apollo.MutationResult<UpdateCuratorTaskRecordMutation>;
export type UpdateCuratorTaskRecordMutationOptions = Apollo.BaseMutationOptions<UpdateCuratorTaskRecordMutation, UpdateCuratorTaskRecordMutationVariables>;
export const DeleteCuratorTaskRecordDocument = gql`
    mutation deleteCuratorTaskRecord($input: GetCuratorTaskInput!) {
  deleteCuratorTaskRecord(input: $input) {
    message
    success
    data {
      curator_task_id
    }
  }
}
    `;
export type DeleteCuratorTaskRecordMutationFn = Apollo.MutationFunction<DeleteCuratorTaskRecordMutation, DeleteCuratorTaskRecordMutationVariables>;
export function useDeleteCuratorTaskRecordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCuratorTaskRecordMutation, DeleteCuratorTaskRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCuratorTaskRecordMutation, DeleteCuratorTaskRecordMutationVariables>(DeleteCuratorTaskRecordDocument, options);
      }
export type DeleteCuratorTaskRecordMutationHookResult = ReturnType<typeof useDeleteCuratorTaskRecordMutation>;
export type DeleteCuratorTaskRecordMutationResult = Apollo.MutationResult<DeleteCuratorTaskRecordMutation>;
export type DeleteCuratorTaskRecordMutationOptions = Apollo.BaseMutationOptions<DeleteCuratorTaskRecordMutation, DeleteCuratorTaskRecordMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetAllCuratorTaskRecordsForPatient = withQueryResponseHandler(useGetAllCuratorTaskRecordsForPatientQuery);
export const useGetAllCuratorTaskRecords = withQueryResponseHandler(useGetAllCuratorTaskRecordsQuery);
export const useGetCuratorTaskRecord = withQueryResponseHandler(useGetCuratorTaskRecordQuery);
export const usePostCuratorTaskRecord = withMutationResponseHandler(usePostCuratorTaskRecordMutation, "postCuratorTaskRecord");
export const useUpdateCuratorTaskRecord = withMutationResponseHandler(useUpdateCuratorTaskRecordMutation, "updateCuratorTaskRecord");
export const useDeleteCuratorTaskRecord = withMutationResponseHandler(useDeleteCuratorTaskRecordMutation, "deleteCuratorTaskRecord");